/**
 * The fee line of a payment card, worded so it reads as a fee.
 *
 * The texts arrive bare — `$1`, `0%`, `may apply` — and a bare `$1` under a "Minimum 5.00 USD"
 * reads as a second amount. A text that already starts with the word keeps its own wording.
 *
 * Returns `''` for nothing to show, which is what the card checks before drawing the line.
 */
export function feeLabel(text: string | null | undefined): string {
  const fee = text?.trim()

  if (!fee) return ''

  return /^fee\b/i.test(fee) ? fee : `Fee ${fee}`
}
